export const computerUnitTypeInSortOrder = ['cloudService', 'remoteServer', 'computer', 'printer'];
